import { createContext, useContext, useEffect, useId, useMemo, useState, } from "react";
export const RequiredFieldsContext = createContext(null);
export function useRegisterRequiredField(isRequired) {
    const registry = useContext(RequiredFieldsContext);
    const id = useId();
    useEffect(() => {
        if (!registry || !isRequired) {
            return;
        }
        registry.register(id);
        return () => registry.unregister(id);
    }, [registry, isRequired, id]);
}
export function useRequiredFieldsRegistry() {
    const [registeredIds, setRegisteredIds] = useState(() => new Set());
    const registry = useMemo(() => ({
        register: (id) => setRegisteredIds((current) => current.has(id) ? current : new Set(current).add(id)),
        unregister: (id) => setRegisteredIds((current) => {
            if (!current.has(id)) {
                return current;
            }
            const next = new Set(current);
            next.delete(id);
            return next;
        }),
    }), []);
    return { hasRequiredFields: registeredIds.size > 0, registry };
}
//# sourceMappingURL=requiredFields.js.map